import React from 'react';
import PropTypes from 'prop-types';
import { CompanySettingsFormView } from './company-settings-form-view';

export const CompanySettingsForm = ({
	change,
	formValues,
	companySettingInfo,
	stages,
	documentTypes,
	isStagesLoading,
	isDocumentsTypesLoading,
}) => {
	return (
		<CompanySettingsFormView
			change={change}
			formValues={formValues}
			companySettingInfo={companySettingInfo}
			stages={stages}
			documentTypes={documentTypes}
			isDocumentsTypesLoading={isDocumentsTypesLoading}
			isStagesLoading={isStagesLoading}
		/>
	);
};

CompanySettingsForm.propTypes = {
	change: PropTypes.func.isRequired,
	formValues: PropTypes.object,
	initialValues: PropTypes.array,
	companySettingInfo: PropTypes.object,
	stages: PropTypes.array,
	documentTypes: PropTypes.array,
	isDocumentsTypesLoading: PropTypes.bool.isRequired,
	isStagesLoading: PropTypes.bool.isRequired,
};
